import _ from "lodash";
import { createSelector } from "reselect";

const getTourPriceInfo = (state) => state.TourPriceInfo;

export const pkgSearchSessionIdSelector = createSelector(
  [getTourPriceInfo],
  (priceInfo) => _.get(priceInfo, "search_data.session_id")
);

const backendSearchStatusesSelector = createSelector(
  [getTourPriceInfo],
  (priceInfo) => {
    return _.get(priceInfo, "search_data.search_statuses", {});
  }
);

const calcBackendSearchingStatus = ({ srvType, searchStatuses }) => {
  const srvTypes = Object.keys(searchStatuses);

  if (srvTypes.length === 0) {
    return -1;
  }

  var isSearching = 0;
  if (!srvTypes.includes(srvType)) {
    return isSearching;
  }

  const statuses = Object.values(_.get(searchStatuses, srvType, {}));

  if (statuses.some((status) => status.status >= 400)) {
    return -1;
  }

  isSearching = statuses.length && statuses.some((status) => status) ? 1 : 0;

  return isSearching;
};

export const backendAccSearchInitiatedSelector = createSelector(
  [backendSearchStatusesSelector],
  (searchStatuses) =>
    calcBackendSearchingStatus({ srvType: "accommodation", searchStatuses })
);

export const backendFlightsSearchInitiatedSelector = createSelector(
  [backendSearchStatusesSelector],
  (searchStatuses) =>
    calcBackendSearchingStatus({ srvType: "flights", searchStatuses })
);

export const backendTransfersIsSearchingSelector = createSelector(
  [backendSearchStatusesSelector],
  (searchStatuses) =>
    calcBackendSearchingStatus({ srvType: "transfers", searchStatuses })
);

const calcSearchingStatus = ({ srvType, searchStatuses }) => {
  const statuses = Object.values(_.get(searchStatuses, srvType, {}));
  if (!statuses.length) {
    return -1;
  }

  const isSearching = statuses.some((status) => status) ? 1 : 0;
  return isSearching;
};

export const accIsSearchingSelector = createSelector(
  [getTourPriceInfo],
  (priceInfo) =>
    calcSearchingStatus({
      srvType: "accommodation",
      searchStatuses: _.get(priceInfo, "search_status", {}),
    })
);

export const flIsSearchingSelector = createSelector(
  [getTourPriceInfo],
  (priceInfo) =>
    calcSearchingStatus({
      srvType: "flights",
      searchStatuses: _.get(priceInfo, "search_status", {}),
    })
);

export const trfIsSearchingSelector = createSelector(
  [getTourPriceInfo],
  (priceInfo) => {
    const searchStatuses = _.get(priceInfo, "search_status", {});
    var statuses = Object.entries(_.get(searchStatuses, "transfers", {})).map(
      (entry) => {
        const trfTypeObject = entry[1];
        return Object.values(trfTypeObject);
      }
    );
    statuses = _.flatten(statuses);

    if (!statuses.length) {
      return -1;
    }

    const isSearching = statuses.some((status) => status) ? 1 : 0;
    return isSearching;
  }
);

const propsInjector = (_, props) => props;

export const destAccResultsUpdatedSelector = createSelector(
  [getTourPriceInfo, propsInjector],
  (priceInfo, props) => {
    const { dest_order } = props;
    const status = _.get(
      priceInfo,
      `update_status.accommodation.${dest_order}`,
      false
    );

    return status;
  }
);

export const isPackageSearchFailedSelector = createSelector([], () => {
  return false;
});
